import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react'

const PaymentErrorPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const orderNumber = searchParams.get('order_id')

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Pembayaran Gagal
          </h1>
          <p className="text-gray-600">
            Maaf, pembayaran Anda tidak dapat diproses. Silakan coba lagi atau hubungi customer service.
          </p>
        </div>

        {orderNumber && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-1">Nomor Pesanan:</p>
            <p className="font-mono font-semibold text-gray-900">{orderNumber}</p>
          </div>
        )}

        <div className="space-y-3">
          <Link
            to="/checkout"
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center justify-center"
          >
            <RefreshCw className="h-5 w-5 mr-2" />
            Coba Lagi
          </Link>
          
          <Link
            to="/cart"
            className="w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors inline-flex items-center justify-center"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Kembali ke Keranjang
          </Link>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            Butuh bantuan? Hubungi customer service kami di{' '}
            <a href="mailto:support@hilaltechnologic.com" className="text-blue-600 hover:text-blue-500">
              support@hilaltechnologic.com
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentErrorPage
